// extracted by mini-css-extract-plugin
export default {"container":"EditNoteForm_container__Rad1o","actions":"EditNoteForm_actions__RKlgA","noteCreatingActions":"EditNoteForm_noteCreatingActions__dlJoy"};